<template>
  <div class="StepThree">
     <el-form label-position="right" label-width="220px" :model="formType" class="animated fadeInUp">
            <el-form-item label="激励股份比例：">
                <el-input class="input txt" :onkeyup="onkeyupTotalrate()" v-model="formType.totalrate" placeholder="请填写"></el-input>
                <span class="tips_span">%</span>
                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">
                      <p>在实施股权激励前，通常需规划好公司用于股权激励的股份总量，包含首期授予以及未来预留的总量；根据一般经验，公司用于股权激励的股权总量不高于30%,10~20%为常见范围。</p>
                      <p>激励股份比例=激励股份总股数÷公司总股本</p>
                    </div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>
            </el-form-item>

            <el-form-item label="激励股份总股数：">
                <el-input class="input txt" v-model="formType.totalsicount" :onkeyup="onkeyupSurrate()" placeholder="自动生成" :disabled="true"></el-input>
                <span class="tips_span">万股</span>
            </el-form-item>

            <el-form-item label="首次激励股份比例：">
                <el-input class="input txt" :onkeyup="onkeyupFirstrate()" v-model="formType.firstrate" placeholder="请填写"></el-input>
                <span class="tips_span">%</span>
                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">
                      <p>首次激励股份比例=首期激励股份数量÷公司总股本</p>
                    </div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>
            </el-form-item>

            <el-form-item label="首次激励股份数量：">
                <el-input class="input txt" v-model="formType.firstsicount"  placeholder="自动生成" :disabled="true"></el-input>
                <span class="tips_span">万股</span>
            </el-form-item>
            <el-form-item label="预留股份比例：">
                <el-input class="input txt" v-model="formType.surrate" placeholder="自动生成" :disabled="true"></el-input>
                <!-- :onkeyup="onkeyupSurrate()"  -->
                <span class="tips_span">%</span>
                <el-tooltip placement="right">
                    <div class="tooltip_content" slot="content">
                      <p>预留股份比例=激励股份比例-首次激励股份比例</p>
                    </div>
                    <img class="tooltip_icon" :src="require('@/common/images/gujingimgs/icon_tip.png')" alt="">
                </el-tooltip>
            </el-form-item>
            <el-form-item label="预留激励股份数量：">
                <el-input class="input txt" v-model="formType.sursicount" placeholder="自动生成" :disabled="true"></el-input>
                <span class="tips_span">万股</span>
            </el-form-item>
            <el-form-item label="目前公司估值：">
                <el-input class="input txt" v-model="formType.evmoney" placeholder="请填写" maxlength="8"></el-input>
                <span class="tips_span">万元</span>
                <el-button type="text" style="margin-left: 10px" @click="goto">快速免费估值<i class="el-icon-d-arrow-right"></i></el-button>
            </el-form-item>

        </el-form>
    <div class="animated fadeInUp btnlist">
        <el-button @click="next(1)" type="primary" plain>上一步</el-button>
        <el-button @click="next(4)" type="primary">生成报告</el-button>
    </div>
    <VerificationCode ref="verificationcode" @getVerificationCode="getVerificationCode"></VerificationCode>
  </div>
</template>

<script>
import $ from 'jquery'
import {dealSwSiOrderinfo} from 'api/gujingApi'
import {mapGetters, mapActions} from 'vuex'
import VerificationCode from '../../components/VerificationCode.vue'
export default {
  name: 'StepThree',
  props: ['formType', 'fileInfo'],
  data () {
    return {
      reg: /^[0-9]+\.{0,1}[0-9]{0,2}$/,
      money: 10000
    }
  },
  mounted () {
    $('html').scrollTop(0)
  },
  methods: {
    next(type) {
      if (type == 1) {
        this.$emit('setStepValue', 1)
      } else {
          if (this.formType.totalrate.length == 0) {
            this.$message.warning('激励股份比例不能为空')
            return
          } else if (this.formType.firstrate.length == 0) {
            this.$message.warning('首次激励股份比例不能为空')
            return
          } else if (this.formType.surrate.length == 0) {
            this.$message.warning('预留股份比例不能为空')
            return
          } else if (this.formType.evmoney.length == 0) {
            this.$message.warning('目前公司估值不能为空')
            return
          } else if (this.formType.evmoney < 1 || this.formType.evmoney > 10000000) {
            this.$message.warning('公司估值在 1 - 10000000 之间')
            return
          } else if (!this.reg.test(this.formType.evmoney)) {
            this.$message.warning('请填写正确的目前公司估值(两位小数内的整数)')
            return
          } else  if (this.formType.firstrate > this.formType.totalrate) {
            this.$message.warning('首次激励股份比例不能超过激励股份比例')
            return
          } else {
            if (this.user.isLogin) {
              this.$refs.verificationcode.start('提交验证码')
            } else {
              this.setLoginPop(true)
            }

            // this.setLoading(true)
            // dealSwSiOrderinfo({
            //   data: this.formType,
            //   success: data => {
            //     this.setLoading(false)
            //     if (data.code == "000") {
            //       this.$emit('setfileInfo', data.data)
            //       this.$emit('setStepValue', 3)
            //     } else {
            //       this.$message.error(data.msg)
            //     }
            //   },
            //   error: data => {
            //     this.setLoading(false)
            //     this.$message.error(data.msg)
            //   }
            // })
          }
      }
    },
    getVerificationCode(verificationCode, codeEncryption) {
      this.formType.usercode = verificationCode
      this.formType.codeEncryption = codeEncryption
      this.formType.clienttype = 1

      // let formType = JSON.parse(JSON.stringify(this.formType))
      // formType.totalsicount = this.transformationgu(formType.totalsicount)
      // formType.firstsicount = this.transformationgu(formType.firstsicount)
      // formType.sursicount = this.transformationgu(formType.sursicount)

       this.setLoading(true)
            dealSwSiOrderinfo({
              data: this.formType,
              success: data => {
                this.setLoading(false)
                if (data.code == "000") {
                  this.$emit('setfileInfo', data.data)
                  this.$emit('setStepValue', 3)
                  
                  this.$refs.verificationcode.close()
                } else {
                  this.$message.error(data.msg)
                }
              },
              error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
              }
            })
    },
    onkeyupTotalrate() {
      if (!this.reg.test(this.formType.totalrate) && this.formType.totalrate.length > 0) {
        this.$message.warning('请填写正确的激励股份比例(两位小数内的整数)')
        return
      } else if (this.formType.totalrate > 100) {
        this.$message.warning('激励股份比例不能超过100%')
        return
      } else {
        let allMoney = this.formType.regcapital * 10000,
            proportion = this.formType.totalrate * 10000
        // 增资扩股情况下 股权激励股份总数 = (注册资本*激励股份比例) / (1-激励股份比例)
        if (this.formType.sharesource == 1) {
          if (this.formType.totalrate == 100) {
             this.formType.totalsicount = (((allMoney * this.formType.totalrate)).toFixed(0) / 10000).toFixed(2)
          } else {
            this.formType.totalsicount = (((allMoney * this.formType.totalrate) / (100 - this.formType.totalrate)).toFixed(0) / 10000).toFixed(2)
          }
        } else {
          this.formType.totalsicount =  (((allMoney * proportion) / 1000000).toFixed(0) / 10000).toFixed(2)
        }

        // this.transformation(this.formType.totalsicount)


        // 计算预留股份比例
        if (this.reg.test(this.formType.totalrate) && this.reg.test(this.formType.firstrate)) {
            this.formType.surrate = this.formType.totalrate - this.formType.firstrate
        }

      }
    },
    onkeyupFirstrate() {
      if (!this.reg.test(this.formType.firstrate) && this.formType.firstrate.length > 0) {
        this.$message.warning('请填写正确的首次激励股份比例(两位小数内的整数)')
        return
      } else if (this.formType.firstrate > this.formType.totalrate) {
        this.$message.warning('首次激励股份比例不能超过激励股份比例')
        return
      } else {

        let allMoney = this.formType.regcapital * 10000,
            proportion = this.formType.firstrate * 10000
        

        // 增值扩容
        if (this.formType.sharesource == 1) {
          // 首次激励股份数量=新注册资本*首次激励股份比例
          // 新注册资本=激励股份总股数 / 激励股份比例
          if (this.formType.totalsicount > 0) {
            let zgb = this.transformationgu(this.formType.totalsicount) / (this.formType.totalrate / 100)
            this.formType.firstsicount =  ((zgb * (this.formType.firstrate / 100)).toFixed(0) / 10000).toFixed(2)
          } else {
            this.formType.firstsicount = ''
          }
        } else {
          this.formType.firstsicount =  (((allMoney * proportion) / 1000000).toFixed(0) / 10000).toFixed(2)
        }

        // this.formType.firstsicount = this.transformation(this.formType.firstsicount)

        // 计算预留激励股份数量
        this.onkeyupSurrate()

        // 计算预留股份比例
        if (this.reg.test(this.formType.totalrate) && this.reg.test(this.formType.firstrate)) {
            
            this.formType.surrate = this.formType.totalrate - this.formType.firstrate
        }
      }
    },
    onkeyupSurrate() {  // 计算预留激励股份数量 预留激励股份数量 = 激励股份总股数 - 首次激励股份数量

      if (this.formType.totalsicount && this.formType.firstsicount) {
        this.formType.sursicount = ((this.transformationgu(this.formType.totalsicount) - this.transformationgu(this.formType.firstsicount)) / 10000).toFixed(2)
      }
    },
    goto() {
      let {href} = this.$router.resolve({name: "EnterpriseEstimation"})
      window.open(href, "_blank")
    },
    // 转换成万股
    transformation(nums) {
      return nums / 10000
    },
     // 转换成股
    transformationgu(nums) {
      return nums * 10000
    },
    ...mapActions(['setLoading', 'setLoginPop'])
  },
  filters: {},
  watch: {},
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  components: {
    VerificationCode
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.StepThree {
  margin-top: 50px;
  background-color: #fff;
  .el-form {
    padding-left: 200px;
  }
}
.tooltip_content {
    p {
      width: 331px;
      strong {
        font-weight: bold;
      }
    }
  }
</style>